import { useEffect, useState } from "react";
import api, { API, fileUrl } from "@/lib/api";

export function ProtectedImage({ src, alt = "", className = "", ...props }) {
  const [objectUrl, setObjectUrl] = useState(null);
  const resolved = fileUrl(src);
  const isInternal = resolved?.startsWith(`${API}/files/`);

  useEffect(() => {
    let active = true;
    let createdUrl = null;

    if (!resolved || !isInternal) {
      setObjectUrl(resolved || null);
      return () => { active = false; };
    }

    setObjectUrl(null);
    api.get(resolved, { responseType: "blob" }).then(({ data }) => {
      if (!active) return;
      createdUrl = URL.createObjectURL(data);
      setObjectUrl(createdUrl);
    }).catch(() => {
      if (active) setObjectUrl(null);
    });

    return () => {
      active = false;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [resolved, isInternal]);

  if (!objectUrl) return null;
  return <img src={objectUrl} alt={alt} className={className} {...props} />;
}